import { CmsValue } from 'core/type/BootstrapConfig.types';
import { PaxTypeCode } from 'gql/autogen/PaxTypeCode';
import { StringFormatter } from '@agoda/react-handyman';
import { PaxStringCmsCodes } from 'core/utils/PaxCounterCms';
import { Pax } from 'gql/autogen/Pax';
import { parseNumber } from 'core/utils/parseNumber';
import { Quantity } from 'gql/autogen/Quantity';

export const getPax = (cms: CmsValue, paxCount = 0, paxCode = PaxTypeCode.PERSON) => {
    const paxCms = PaxStringCmsCodes[paxCode] || PaxStringCmsCodes[PaxTypeCode.PERSON];
    if (paxCount > 1) {
        return StringFormatter.format(cms[paxCms.plural], paxCount.toString());
    }
    return cms[paxCms.singular];
};

export const PaxTypeCodeToIdMap: Record<PaxTypeCode, number> = {
    [PaxTypeCode.TICKET]: 1,
    [PaxTypeCode.STUDENT]: 2,
    [PaxTypeCode.TODDLER]: 3,
    [PaxTypeCode.INFANT]: 4,
    [PaxTypeCode.SENIOR]: 5,
    [PaxTypeCode.YOUTH]: 6,
    [PaxTypeCode.CHILD]: 7,
    [PaxTypeCode.ADULT]: 8,
    [PaxTypeCode.PERSON]: 9,
    [PaxTypeCode.BOOK]: 10,
    [PaxTypeCode.UNKNOWN]: 11,
};

const getPaxTypeFromId = (id: number): PaxTypeCode => {
    const entry = Object.entries(PaxTypeCodeToIdMap).find(([key, value]) => value === id);
    return entry ? (entry[0] as PaxTypeCode) : PaxTypeCode.UNKNOWN;
};

export const mapPaxFromQueryParams = (paxString: string): Pax[] => {
    return paxString.split(',').map((paxPair) => {
        const [paxTypeCodeStr, quantityStr] = paxPair.split('_');

        const code = getPaxTypeFromId(parseNumber(paxTypeCodeStr));
        const value = parseNumber(quantityStr);

        const quantity: Quantity = { value };
        return {
            code,
            quantity,
        };
    });
};
